"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServerRenderHash = isServerRenderHash;
exports.isPromise = isPromise;
function isServerRenderHash(testValue) {
    return !!(testValue.renderedHtml ||
        testValue.redirectLocation ||
        testValue.routeError ||
        testValue.error);
}
function isPromise(testValue) {
    return !!(testValue?.then);
}
